export default {
  'realtime_users_title': 'Realtime Users',
  'realtime_users_time_zone': 'Timezone',
  'realtime_users_tab1': 'Users',
  'realtime_users_tab2': 'By country/region/zone',
  'realtime_users_tab3': 'Change Analysis',
  'realtime_users_tab4': 'Data Download',
  'realtime_users_country_platform': 'By Region/Platform',

  'realtime_users_refresh_text': 'Auto refresh every 5 minutes',

  // 卡片
  'realtime_users_new_users_card_title': 'New Users',
  'realtime_users_active_users_card_title': 'Active Users',
  'realtime_users_online_users_card_title': 'Concurrent Users',
  'realtime_users_d2_card_title': 'D2(T-1)',
  'realtime_users_d3_card_title': 'D3(T-2)',
  'realtime_users_d7_card_title': 'D7(T-6)',

  'realtime_users_d2_card_title_pc': 'D1(T-1)',
  'realtime_users_d3_card_title_pc': 'D2(T-2)',
  'realtime_users_d7_card_title_pc': 'D7(T-7)',


  'realtime_users_new_tab': 'New',
  'realtime_users_active_tab': 'Active',
  'realtime_users_online_tab': 'Concurrent',
  'realtime_users_ccu_tab': 'CCU',
  'realtime_users_d2_tab': 'Retention D2',
  'realtime_users_d3_tab': 'Retention D3',
  'realtime_users_d7_tab': 'Retention D7',

  'realtime_users_d2_tab_pc': 'Retention D1',
  'realtime_users_d3_tab_pc': 'Retention D2',
  'realtime_users_d7_tab_pc': 'Retention D7',

  'realtime_users_new_title': 'Realtime Daily Accumulated New Users (5 min)',
  'realtime_users_active_title': 'Realtime Daily Accumulated Active Users (5 min)',
  'realtime_users_online_title': 'Realtime Concurrent Users (5 min)',
  'realtime_users_d2_title': 'Retention D2 (1 hour)',
  'realtime_users_d3_title': 'Retention D3 (1 hour)',
  'realtime_users_d7_title': 'Retention D7 (1 hour)',

  'realtime_users_d2_title_pc': 'Retention D1 (1 hour)',
  'realtime_users_d3_title_pc': 'Retention D2 (1 hour)',
  'realtime_users_d7_title_pc': 'Retention D7 (1 hour)',

  'realtime_by_country_statistical_time': 'Statistical Time',
  'realtime_by_country_register_date': 'Register Date',
  'realtime_by_country_table_time': 'Time',
  'realtime_by_country_table_zone': 'Zone',
  'realtime_by_country_table_region': 'Region',
  'realtime_by_country_table_country': 'Country',
  'realtime_by_country_table_system': 'Platform',
  'realtime_by_country_table_channel': 'Channel',
  'realtime_by_country_table_category': 'Product Category',
  'realtime_by_country_table_product': 'Product',
  'realtime_by_country_table_language': 'Language',
  'realtime_by_country_table_ad_format': 'Ad Format',
  'realtime_by_country_table_ua_network': 'Media Channel',
  'realtime_by_country_table_new_users': 'New Users',
  'realtime_by_country_table_active_users': 'Active Users',
  'realtime_by_country_table_online_users': 'Concurrent Users',
  'realtime_by_country_table_d2': 'D2',
  'realtime_by_country_table_d3': 'D3',
  'realtime_by_country_table_d7': 'D7',

  'realtime_by_country_table_d2_pc': 'D1',
  'realtime_by_country_table_d3_pc': 'D2',
  'realtime_by_country_table_d7_pc': 'D7',

  'realtime_by_country_new_tab': 'New',
  'realtime_by_country_active_tab': 'Active',
  'realtime_by_country_online_tab': 'Concurrent',
  'realtime_by_country_d2_tab': 'Retention D2',
  'realtime_by_country_d3_tab': 'Retention D3',
  'realtime_by_country_d7_tab': 'Retention D7',

  'realtime_by_country_new_title': 'Realtime Daily Accumulated New Users (5 min)',
  'realtime_by_country_active_title': 'Realtime Daily Accumulated Active Users (5 min)',
  'realtime_by_country_online_title': 'Realtime Concurrent Users(5 min)',
  'realtime_by_country_d2_title': 'Retention D2 (1 hour)',
  'realtime_by_country_d3_title': 'Retention D3 (1 hour)',
  'realtime_by_country_d7_title': 'Retention D7 (1 hour)',

  'realtime_by_platform_by_country': 'By Country',
  'realtime_by_platform_by_region': 'By Region',
  'realtime_by_platform_by_platform': 'By Platform',

  'realtime_register_date': 'Register Date',
  'realtime_total_new': 'Total New',


  // download
  'realtime_download_table_time': 'Time',
  'realtime_download_table_new': 'NEW',
  'realtime_download_table_dau': 'DAU',
  'realtime_download_table_online': 'Concurrent',
  'realtime_download_users_title': 'Users Data Overall Performance',
  'realtime_download_retention_title': 'Retention Overall Performance',

  'realtime_metrics': 'Read realtime metrics data of top 5 & others by dimension.',

  // change analysis
  'realtime_change_analysis_allCountry': 'All Countries',
  'realtime_change_analysis_keyCountries': 'Key Countries',
  'realtime_change_analysis_topChangeNewTitle': 'Top Change - Realtime Daily Accumulated New Users (5 min)',
  'realtime_change_analysis_country': 'Country',
  'realtime_change_analysis_new': 'New',
  'realtime_change_analysis_change': 'Change',
  'realtime_change_analysis_topChangeActiveTitle': 'Top Change - Realtime Daily Accumulated Active Users (5 min)',
  'realtime_change_analysis_topChangeD2Title': 'Top Change - Retention D2 (1 hour)',
  'realtime_change_analysis_topChangeD3Title': 'Top Change - Retention D3 (1 hour)',
  'realtime_change_analysis_topChangeD7Title': 'Top Change - Retention D7 (1 hour)',

  // 指标卡片解释
  'realtime_metrics_card_title': 'Realtime Key Metrics',
  'realtime_metrics_card_modal_title': 'Realtime Key Metrics Explanation',
  'realtime_metrics_card_modal_table_header_metrics': 'Metrics',
  'realtime_metrics_card_modal_table_header_explanation': 'Explanation',
  'realtime_metrics_card_modal_table_new_users': 'New Users',
  'realtime_metrics_card_modal_table_new_users_explain': 'Total number of newly-registered users from 0:00 to the current statistical time point on the statistical day (vopenid deduplicated from Play Register ).',
  'realtime_metrics_card_modal_table_active_users': 'Active Users',
  'realtime_metrics_card_modal_table_active_users_explain': 'Total number of users who have logged in to the game during the period from 0:00 to the current statistical time point on the statistical day (vopenid deduplicated from Play Login).',
  'realtime_metrics_card_modal_table_online_users': 'Concurrent Users',
  'realtime_metrics_card_modal_table_online_users_explain': 'Total number of concurrent users at the current statistical time point.',
  'realtime_metrics_card_modal_table_d2': 'D2(T-1)',
  'realtime_metrics_card_modal_table_d2_explain': 'Take T as the statistical day. Number of retained users from 0:00 to the current statistical time point on the statistical day / Number of new users on the day before the statistics day (T-1, registration date).',
  'realtime_metrics_card_modal_table_d3': 'D3(T-2)',
  'realtime_metrics_card_modal_table_d3_explain': 'Take T as the statistical day. Number of retained users from 0:00 to the current statistical time point on the statistical day / Number of new users on two days before the statistics day (T-2, registration date).',
  'realtime_metrics_card_modal_table_d7': 'D7(T-6)',
  'realtime_metrics_card_modal_table_d7_explain': 'Take T as the statistical day. Number of retained users from 0:00 to the current statistical time point on the statistical day / Number of new users on six days before the statistics day (T-6, registration date).',
  'realtime_metrics_card_modal_table_dod': 'DoD',
  'realtime_metrics_card_modal_table_dod_explain_1': 'Day-on-day . (The cumulative data at the current statistical time point on the statistical day - the cumulative data at the same time point yesterday) / the cumulative data at the same time point yesterday',
  'realtime_metrics_card_modal_table_dod_explain_2': 'Take new users as an example (T as the statistical day): DoD = (new users (T) - new users (T-1)) / new users (T-1)',
  'realtime_metrics_card_modal_table_sdlw': 'SDLW',
  'realtime_metrics_card_modal_table_sdlw_explain_1': 'Same-day-last-week .  (The cumulative data at the current statistical time point on the statistical day - the cumulative data at the same time point last week) / the cumulative data at the same time point last week',
  'realtime_metrics_card_modal_table_sdlw_explain_2': 'Take new users as an example (T as the statistical day): SDLW= (new users (T) - new users (T-7)) / new users (T-7)',


  'realtime_metrics_card_modal_table_d2_explain_pc': 'The retention rate of new register users on day 1. Number of retained users on day 1 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.',

  'realtime_metrics_card_modal_table_d3_explain_pc': 'The retention rate of new register users on day 2. Number of retained users on day 2 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.',

  'realtime_metrics_card_modal_table_d7_explain_pc': 'The retention rate of new register users on day7. Number of retained users on day 7 from XX (registration date) / Number of new users on XX (registration date). Registration date is day 0.',


  // 异动
  'realtime_analysis': 'Change Analysis',
  'realtime_analysis_All_Countries': 'Total',
  'realtime_analysis_Key_country': 'Key Country/Market',

  'realtime_analysis_Country': 'Country',
  'realtime_analysis_New': 'New',
  'realtime_analysis_Active': 'Active',
  'realtime_analysis_Online': 'Concurrent',
  'realtime_analysis_Change': 'Change%',
  'realtime_analysis_Change_Value': 'Change',
  'realtime_analysis_Change_Of_New': 'Change of New',
  'realtime_analysis_D2': 'D2',
  'realtime_analysis_D3': 'D3',
  'realtime_analysis_D7': 'D7',

  'realtime_analysis_D2_pc': 'D1',
  'realtime_analysis_D3_pc': 'D2',
  'realtime_analysis_D7_pc': 'D7',

  'realtime_analysis_Title_1': 'Top 20 countries by Realtime Daily Accumulated New Users Change (5min)',
  'realtime_analysis_Title_2': 'Top 20 countries by Realtime Daily Accumulated Active Users Change (5min)',
  'realtime_analysis_Title_3': 'Top 20 countries by Realtime Concurrent Users Change (5min)',
  'realtime_analysis_Title_4': 'Top 20 countries by Retention D2 Change (1 hour)',
  'realtime_analysis_Title_5': 'Top 20 countries by Retention D3 Change (1 hour)',
  'realtime_analysis_Title_6': 'Top 20 countries by Retention D7 Change (1 hour)',

  'realtime_analysis_Title_4_pc': 'Top 20 countries by Retention D1 Change (1 hour)',
  'realtime_analysis_Title_5_pc': 'Top 20 countries by Retention D2 Change (1 hour)',
  'realtime_analysis_Title_6_pc': 'Top 20 countries by Retention D7 Change (1 hour)',

  'realtime_analysis_Title_4_pc_base': 'Top 20 countries by Retention D1 Change (1 hour)',
  'realtime_analysis_Title_5_pc_base': 'Top 20 countries by Retention D2 Change (1 hour)',
  'realtime_analysis_Title_6_pc_base': 'Top 20 countries by Retention D7 Change (1 hour)',

  'realtime_analysis_table_title_new_left': 'Top Change by Country (Left table)-New Users',
  'realtime_analysis_table_title_active_left': 'Top Change by Country (Left table)-Active Users',
  'realtime_analysis_table_title_online_left': 'Top Change by Country (Left table)-Concurrent Users',
  'realtime_analysis_table_title_d2_left': 'Top Change by Country (Left table)-D2',
  'realtime_analysis_table_title_d3_left': 'Top Change by Country (Left table)-D3',
  'realtime_analysis_table_title_d7_left': 'Top Change by Country (Left table)-D7',

  'realtime_analysis_table_title_new_right_5min': '5min-Realtime Detail Data(Right Trends)-New Users',
  'realtime_analysis_table_title_active_right_5min': '5min-Realtime Detail Data(Right Trends)-Active Users',
  'realtime_analysis_table_title_online_right_5min': '5min-Realtime Detail Data(Right Trends)-Concurrent Users',
  'realtime_analysis_table_title_new_right_1hour': '1hour-Realtime Detail Data(Right Trends)-New Users',
  'realtime_analysis_table_title_active_right_1hour': '1hour-Realtime Detail Data(Right Trends)-Active Users',
  'realtime_analysis_table_title_online_right_1hour': '1hour-Realtime Detail Data(Right Trends)-Concurrent Users',
  'realtime_analysis_table_title_d2_right_1hour': '1hour-Realtime Detail Data(Right Trends)-D2',
  'realtime_analysis_table_title_d3_right_1hour': '1hour-Realtime Detail Data(Right Trends)-D3',
  'realtime_analysis_table_title_d7_right_1hour': '1hour-Realtime Detail Data(Right Trends)-D7',

  'realtime_analysis_Register_Date': 'Register Date',
  'realtime_analysis_Statistical_Time': 'Statistical Time',
  'realtime_analysis_Time': 'Time',
  'realtime_analysis_Global': 'Total',
  'realtime_analysis_Total': 'Total',
  'realtime_analysis_.Change': 'Change',
  'realtime_analysis_bubbleText': 'A maximum of 10 items can be checked, please cancel and reselect',
  'realtime_analysis_tabBubbleText': 'The key countries that the game focuses on, directly given by the game team.',
  // v2.15版本新增需求 右上角的切换按钮
  'realtime_analysis_Same_Trend': 'Same Trend as Total',
  'realtime_analysis_Same_Trend_Total': 'Same Trend as Total',
  'realtime_analysis_Opposite_Trend': 'Opposite Trend to Total',
  'realtime_analysis_Opposite_Trend_Total': 'Opposite Trend to Total',
  'realtime_analysis_All_Trend': 'All Change Trend',
  'realtime_analysis_trendTips': 'By default, countries with the all change trend are displayed, and you can switch to countries with same trends/opposite trends.',


};
